export const DOWNLOAD_INVOICE_TOOLTIP = 'Baixar fatura'
